import { createTheme, Theme } from "@valenzinsights/core-component";

import { orangeTheme } from "./orangeTheme";


const overrideOrangeTheme = (theme: Theme) => {
	const primary = theme.palette.primary;
	const secondary = theme?.palette?.secondary ?? theme.palette.primary;
	const error = theme.palette.error;
	const success = theme.palette.success;
	const grey = theme.palette.grey;
	const ternary = theme.palette.ternary ?? theme.palette.primary;

	const warning = theme.palette.warning;
	const info = theme.palette.info;
	return createTheme({
		typography: theme.typography,
		palette: {
			...theme.palette,
			background: {
				...theme.palette.background,
				analytics: {
					chart1: [
						secondary?.light ?? primary.light,
						ternary.main,
						primary?.main,
						ternary?.[500] ?? ternary.main,
						primary.light,
						secondary.main,
						ternary.dark
					],
					chart2: [
						secondary.main,
						secondary?.[300] ?? secondary.main,
						success.main,
						primary.main,
					],
					chart3: [ternary.main, ternary.dark, secondary.main, primary.main],
					chart4: [ternary.main],
				},
			},
		},
		components: {
			MuiButton: {
				variants: [
					{
						props: { variant: "neutral" },
						style: {
							color: theme.palette.common.white,
							backgroundColor: grey[600],
							"&:hover": {
								backgroundColor: grey[800],
							},
						},
					},
				],
				styleOverrides: {
					root: {
						"&.Mui-disabled": {
							color: grey[600],
							backgroundColor: grey[500],
						},
					},
				},
			},
			MuiSvgIcon: {
				styleOverrides: {
					root: {
						"&.MuiSvgIcon-colorSuccess": {
							color: success.main + "!important", // Replace with your success.main
						},
					},
					colorPrimary: {
						color: secondary.main,
					},
					colorAction: {
						color: grey[400],
					},
					colorDisabled: {
						color: grey[400] + "!important",
					},
					colorError: {
						color: `${error.main} !important`,
					},
					fontSizeMedium: {
						color: secondary.main,
					},
				},
			},
			MuiSwitch: {
				styleOverrides: {
					root: {
						"& .MuiSwitch-thumb": {
							backgroundColor: grey[100],
						},
						"& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
							backgroundColor: secondary.main + " !important",
						},
					},
					track: {
						backgroundColor: grey[700],
						".Mui-checked + &": {
							backgroundColor: secondary.main + " !important",
						},
					},
				},
			},
			MuiChip: {
				styleOverrides: {
					colorSuccess: {
						backgroundColor: success.lighter,
						color: success.main,
					},
					colorError: {
						backgroundColor: error.lighter,
						color: error.main,
					},
					colorPrimary: {
						backgroundColor: primary.lighter,
						color: primary.main,
					},
					colorWarning: {
						backgroundColor: warning.lighter,
						color: warning.main,
					},
					colorInfo: {
						backgroundColor: secondary.lighter,
						color: secondary.main,
					}
				},
			},
			MuiTab: {
				styleOverrides: {
					root: {
						fontSize: theme.typography.body1.fontSize,
					},
				},
			},
			MuiLink: {
				styleOverrides: {
					root: {
						cursor: "pointer",
					},
				},
			},
			MuiStepIcon: {
				styleOverrides: {
					root: {
						"&.Mui-active": {
							color: success.main + "!important",
						},
						"&.Mui-completed": {
							color: success.main
						}
					}
				}
			},
			MuiFormHelperText: {
				styleOverrides: {
					root: {
						"&.Mui-error": {
							position: "absolute",
							top: "100%",
						}
					}
				}
			}
		},
	});
};

export const cutomOrangeTheme = overrideOrangeTheme(orangeTheme);
